export default "__VITE_ASSET__Bm5wX5Mg__"